

const UnAuthorizedUser = () => {
    return (
        <>

            <div className="flex">
                <h1>unauthorized user</h1>
            </div>
        </>
    )
}

export { UnAuthorizedUser }